import { fileInputMultipleUI } from 'platform/forms-system/src/js/web-component-patterns';
import DualFileUploadField from './DualFileUploadField';

/**
 * Wraps the platform's fileInputMultipleUI with the CAVE-aware
 * DualFileUploadField so consumers get dual-upload behavior (primary +
 * CAVE secondary) without manually overriding `ui:webComponentField`.
 *
 * Accepts the same options as fileInputMultipleUI.
 * @param {Parameters<typeof fileInputMultipleUI>[0]} options
 * @returns {ReturnType<typeof fileInputMultipleUI>}
 */
export const caveMultiFileUploader = options => ({
  ...fileInputMultipleUI(options),
  'ui:webComponentField': DualFileUploadField,
});
